import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import './SimpleRichEditor.css';

const MenuBar = ({ editor }) => {
  if (!editor) return null;

  return (
    <div style={{
      display: 'flex',
      gap: '2px',
      padding: '4px 8px',
      borderBottom: '1px solid #E5E7EB',
      background: '#FAFAFA',
    }}>
      <button
        type="button"
        onMouseDown={(e) => { e.preventDefault(); editor.chain().focus().toggleBold().run(); }}
        style={{
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '14px',
          background: editor.isActive('bold') ? '#F3F0FF' : 'transparent',
          color: editor.isActive('bold') ? '#7c3aed' : '#6B7280',
        }}
      >
        B
      </button>
      <button
        type="button"
        onMouseDown={(e) => { e.preventDefault(); editor.chain().focus().toggleItalic().run(); }}
        style={{
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontStyle: 'italic',
          fontSize: '14px',
          background: editor.isActive('italic') ? '#F3F0FF' : 'transparent',
          color: editor.isActive('italic') ? '#7c3aed' : '#6B7280',
        }}
      >
        I
      </button>
      <button
        type="button"
        onMouseDown={(e) => { e.preventDefault(); editor.chain().focus().toggleBulletList().run(); }}
        style={{
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          background: editor.isActive('bulletList') ? '#F3F0FF' : 'transparent',
          color: editor.isActive('bulletList') ? '#7c3aed' : '#6B7280',
        }}
      >
        •≡
      </button>
    </div>
  );
};

const SimpleRichEditor = ({ value, onChange, placeholder }) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        // Enable formatting we need
        bulletList: true,
        listItem: true,
        bold: true,
        italic: true,
        // Disable what we don't need
        heading: false,
        codeBlock: false,
        blockquote: false,
        horizontalRule: false,
        code: false,
        strike: false,
      }),
      Placeholder.configure({
        placeholder: placeholder || 'Start typing...',
      }),
    ],
    content: value || '',
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      // Don't save empty editor state
      if (html === '<p></p>') {
        onChange('');
      } else {
        onChange(html);
      }
    },
  });

  return (
    <div style={{
      border: '1px solid #E5E7EB',
      borderRadius: '8px',
      overflow: 'hidden',
    }}>
      <MenuBar editor={editor} />
      <EditorContent
        editor={editor}
        style={{ minHeight: '80px' }}
      />
    </div>
  );
};

export default SimpleRichEditor;
